import React from "react";
import { Col, Row, Spin } from "antd";
import { user as userApi } from "../../apis";
import { PageContainer, PageContent, PageHeader } from "../../components/Layout";
import { useParams } from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import Form from "./Form";
import { useTranslate } from "../../hooks";

export default () => {
  const params = useParams();
  const [user, fetching] = useFetch(userApi.get, params.id)([]);
  const { translate } = useTranslate();

  return (
    <Spin spinning={fetching}>
      <PageContainer>
        <PageHeader title= {translate("appuser.edit.pageheader.title", "Edit user")} />
        <Row>
          <Col xs={24} sm={24} md={20} lg={18} xl={14} xxl={12}>
            <PageContent>
              {!fetching && (
                <Form action={["update", user]} />
              )}
            </PageContent>
          </Col>
        </Row>
      </PageContainer>
    </Spin>
  );
};